import React from "react";
import { Clock, ChevronRight, Radio } from "lucide-react";

interface TimeButtonProps {
  onClick: () => void;
  totalDays: number;
  totalSlots: number;
}

const TimeLogAltimeterButton = ({ onClick, totalDays, totalSlots }: TimeButtonProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="group relative flex items-center gap-6 p-1 pr-6 bg-[#0F172A] border-2 border-slate-800 rounded-2xl hover:border-orange-500/50 transition-all duration-500 hover:shadow-[0_0_30px_rgba(242,108,21,0.15)] active:scale-[0.98]"
    >
      {/* Secțiunea Stânga: Simulează un ceas analogic/radar */}
      <div className="relative h-20 w-20 bg-black rounded-xl border-r-2 border-slate-800 flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-orange-500/10 via-transparent to-transparent"></div>

        {/* Liniile de scanare radar animate discret */}
        <div className="absolute inset-0 opacity-20">
            <div className="absolute top-1/2 left-0 w-full h-[1px] bg-orange-500"></div>
            <div className="absolute top-0 left-1/2 w-[1px] h-full bg-orange-500"></div>
        </div>

        <Clock size={28} className="text-[#f26c15] relative z-10 animate-pulse" />

        {/* Indicator "ON AIR" / Status */}
        <div className="absolute bottom-1 right-1 flex items-center gap-1">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 shadow-[0_0_5px_emerald]"></span>
            <span className="text-[7px] font-black text-emerald-500/80 tracking-tighter">READY</span>
        </div>
      </div>

      {/* Secțiunea Centrală: Data Display (ca un Transponder) */}
      <div className="flex flex-col items-start gap-1">
        <div className="flex items-center gap-2">
            <Radio size={12} className="text-slate-500" />
            <span className="text-[9px] font-black text-slate-500 uppercase tracking-[0.3em]">Scheduler System</span>
        </div>

        <div className="flex items-baseline gap-2">
            <span className="text-3xl font-black text-white font-mono tracking-tighter italic">
                {totalDays.toString().padStart(2, '0')}
            </span>
            <span className="text-[10px] font-bold text-slate-400 uppercase">Days</span>

            <div className="h-4 w-[1px] bg-slate-800 mx-1"></div>

            <span className="text-2xl font-black text-orange-500 font-mono tracking-tighter italic">
                {totalSlots.toString().padStart(3, '0')}
            </span>
            <span className="text-[10px] font-bold text-slate-400 uppercase">Slots</span>
        </div>

        <p className="text-[9px] font-bold text-blue-400/60 uppercase tracking-widest group-hover:text-blue-400 transition-colors">
            Click to reconfigure availability
        </p>
      </div>

      {/* Secțiunea Dreapta: Săgeata de acces */}
      <div className="ml-auto">
        <div className="p-2 rounded-full bg-slate-900 border border-slate-800 group-hover:bg-orange-500 group-hover:text-white group-hover:border-orange-400 transition-all">
            <ChevronRight size={18} />
        </div>
      </div>

      {/* Glow discret pe fundal */}
      <div className="absolute -inset-0.5 bg-gradient-to-r from-orange-500/0 via-orange-500/5 to-orange-500/0 opacity-0 group-hover:opacity-100 transition-opacity rounded-2xl pointer-events-none"></div>
    </button>
  );
};

export default TimeLogAltimeterButton;